import { Route, Redirect } from 'react-router-dom';
import PropTypes from 'prop-types';

import { DefaultTemplate } from '../../../components/templates';
import getLocalToken from '../getLocalToken';

const PrivateRoute = ({ path, component: Component }) => {
  const token = getLocalToken();

  return (
    <Route path={path}>
      <DefaultTemplate>
        {token ? <Component /> : <Redirect to="/login" />}
      </DefaultTemplate>
    </Route>
  );
};

PrivateRoute.propTypes = {
  path: PropTypes.string.isRequired,
  component: PropTypes.node.isRequired,
};

export default PrivateRoute;
